import React from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from 'react-custom-scrollbars';

const CustomScrollbars = ({children, ...rest}) => (
  <Scrollbars
    {...rest}
    renderThumbHorizontal={props => <div {...props} className="custom_scrollbars__thumb" />}
    renderThumbVertical={props => <div {...props} className="custom_scrollbars__thumb" />}
  >
    {children}
  </Scrollbars>
);

CustomScrollbars.propTypes = {
  children: PropTypes.node.isRequired
};

export default CustomScrollbars;



// WEBPACK FOOTER //
// ./components/CustomScrollbars.jsx